import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserModule } from './user/user.module';
import { NgbModule, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { InternalServerErrorModalComponent } from './modals/internal-server-error-modal/internal-server-error-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './_interceptor';
import { HeaderModule } from './header/header.module';
import { SearchModule } from './search/search.module';
import { FooterModule } from './footer/footer.module';
import { HomeModule } from './home/home.module';
import { AccountModule } from './account/account.module';
import { PolicyModule } from './policy/policy.module';
import { ClaimModule } from './claim/claim.module';
import { ReportsModule } from './reports/reports.module';
import { LoginModule } from './login/login.module';
import { EndorsementModule } from './endorsement/endorsement.module';
import { AdminModule } from './admin/admin.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DiceModule } from './dice/dice.module';
import { PsiCustomAdapter } from './_class/psi-custom-adapter';
import { PsiCustomDateParserFormatter } from './_class/psi-custom-date-parser-formatter';
import { SubmissionsModule } from './submissions/submissions.module';
import { NewBusinessModule } from './new-business/new-business.module';
import { DataLostWarningModalComponent } from './modals/data-lost-warning-modal/data-lost-warning-modal.component';
import { RenewalsModule } from './renewals/renewals.module';
import { CurrencyPipe } from '@angular/common';
import { StartRenewalModule } from './renewals/start-renewal/start-renewal.module';

@NgModule({
  declarations: [
    AppComponent,
    InternalServerErrorModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoginModule,
    HeaderModule,
    SearchModule,
    UserModule,
    HomeModule,
    AccountModule,
    PolicyModule,
    ClaimModule,
    AdminModule,
    NewBusinessModule,
    DiceModule,
    ReportsModule,
    EndorsementModule,
    SubmissionsModule,
    RenewalsModule,
    FooterModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    CurrencyPipe,
    httpInterceptorProviders,
    {provide: NgbDateAdapter, useClass: PsiCustomAdapter},
    {provide: NgbDateParserFormatter, useClass: PsiCustomDateParserFormatter}
  ],
  bootstrap: [AppComponent],
  entryComponents: [InternalServerErrorModalComponent, DataLostWarningModalComponent]
})
export class AppModule { }
